export const MECHANICAL_INFORMATION_FORM_FIELDS = {
    usedTranzaura: 'usedTranzaura',
    contactTimeDetails: 'contactTimeDetails',
    engineeringStatement: 'engineeringStatement',
    busAuthorizedStatus: 'busAuthorizedStatus',
    timeCleared: 'timeCleared',
    bonnetNumber: 'bonnetNumber',
    substitutionTime: 'substitutionTime',
} as const
